/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsInvestmentDetails204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsInvestmentDetails505Schema = z.any();

export const optionsInvestmentDetailsMutationResponseSchema = z.lazy(() => optionsInvestmentDetails204Schema);
